module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Members":"Mitglieder","Customers":"Kunden","Customer Groups":"Kundengruppen"}}')
  delete Component.options._Ctor
}
